import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import Page from '../components/Page'
import Button from '../components/Button'

interface NotFoundProps extends RouteComponentProps {}

class NotFound extends Component<NotFoundProps> {
  constructor (props: NotFoundProps) {
    super(props)
    this.handleReturnClick = this.handleReturnClick.bind(this)
  }

  handleReturnClick () {
    this.props.history.push(routes.signIn)
  }

  render () {
    return (
      <Page size='half'>
        <div className="flex flex-col items-center mt-40">
          <h2 className="text-7xl font-medium">404</h2>
          <p className="text-lg mb-4">{i18n("Page Not Found")}</p>
          <Button
            text={i18n("Return")}
            onClick={this.handleReturnClick} />
        </div>
      </Page>
    )
  }
}

export default withRouter(NotFound)
